import { render, staticRenderFns } from "./PostOffices.vue?vue&type=template&id=afbe29f6&scoped=true&"
import script from "./PostOffices.vue?vue&type=script&lang=js&"
export * from "./PostOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbe29f6",
  null
  
)

export default component.exports